import { createContext, useContext } from "react";
import { AccordionVariant } from "./accordion.types";

export const AccordionContext = createContext<{
    isItemActive: (value: string) => boolean;
    hasItemBeenOpened: (value: string) => boolean;
    isMenuOpened: (value: string) => boolean;
    openMenu: (value: string) => void;
    closeMenu: (value: string) => void;
    toggleMenu: (value: string) => void;
    variant: AccordionVariant;
}>({
    isItemActive: () => false,
    hasItemBeenOpened: () => false,
    isMenuOpened: () => false,
    openMenu: () => {},
    closeMenu: () => {},
    toggleMenu: () => {},
    variant: "card",
});
export const AccordionItemContext = createContext<{ value: string }>({ value: "" });

export const useAccordionContext = () => useContext(AccordionContext);
export const useAccordionItemContext = () => useContext(AccordionItemContext);
